class BeforeAfterSlider {
    constructor(sliderElement) {
        this.slider = sliderElement;
        this.before = this.slider.querySelector('.before-image');
        this.beforeImage = this.before.querySelector('img ,svg');
        this.resizer = this.slider.querySelector('.resizer');
        this.active = false;

        this.init();
    }

    init() {
        this.resetSlider();

        // Event Listeners
        window.addEventListener('resize', () => this.resetSlider());
        this.resizer.addEventListener('mousedown', () => this.startResize());
        document.body.addEventListener('mouseup', () => this.stopResize());
        document.body.addEventListener('mouseleave', () => this.stopResize());
        document.body.addEventListener('mousemove', (e) => this.moveResize(e));

        this.resizer.addEventListener('touchstart', () => this.startResize());
        document.body.addEventListener('touchend', () => this.stopResize());
        document.body.addEventListener('touchcancel', () => this.stopResize());
        document.body.addEventListener('touchmove', (e) => this.moveResize(e));
    }

    resetSlider() {
        let width = this.slider.offsetWidth;
        this.beforeImage.style.width = width + 'px';
        this.before.style.width = width / 2 + 'px';
        this.resizer.style.left = width / 2 + 'px';
    }

    startResize() {
        this.active = true;
        this.resizer.classList.add('resize');
    }

    stopResize() {
        this.active = false;
        this.resizer.classList.remove('resize');
    }

    moveResize(e) {
        if (!this.active) return;
        let x = (e.pageX || e.changedTouches?.[0]?.pageX) - this.slider.getBoundingClientRect().left;
        this.slideIt(x);
        this.pauseEvent(e);
    }

    slideIt(x) {
        let minLimit = 30;
        let maxLimit = this.slider.offsetWidth - 30;
        let transform = Math.max(minLimit, Math.min(x, maxLimit));

        this.before.style.width = transform + "px";
        this.resizer.style.left = transform + "px";
    }

    pauseEvent(e) {
        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
    }
}

// Initialize for all sliders on the page
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.before-after-slider').forEach(slider => new BeforeAfterSlider(slider));
});
